module.exports = __webpack_public_path__ + "img/ic-header-orders.73785e97.svg";